<template>
    <dv-scroll-board :config="config" style="width:100%;height:100%;" />
  </template>
  
  <script>
  //专区排行
  export default {
    name: "AirList",
    data() {
      return {
        config: {},
      }
    },
    methods:{
      generatePastDaysData() {
        const data = [];
        const today = new Date();
        
        for (let i = 5; i >= 0; i--) {
          const date = new Date(today);
          date.setDate(today.getDate() - i);
          
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const dateStr = `${year}-${month}-${day}`;
          
          const temp = Math.floor(Math.random() * (32 - 23 + 1)) + 23;
          const humidity = Math.floor(Math.random() * (22 - 18 + 1)) + 18;
          
          data.push([dateStr, `${temp}℃`, `${humidity}%`]);
        }
        
        return data;
      }
    },
    created() {
  
       let data = this.generatePastDaysData();
  
        this.config = {
          header: ['日期', '温度', '湿度'],
          rowNum:[4],
          data: data,
          headerBGC: '#0081EE',
          oddRowBGC: '#0e0e26',
          evenRowBGC: '#0e0e26',
          index: true,
          columnWidth: [50,320],
          align: ['center']
        }
  
  
    },
  
    watch: {
  
    }
  }
  </script>
  
  <style scoped>
  
  </style>